import type { z } from 'zod';

import {
  indexSearchSchema,
  listParams,
  type ListParams,
} from '@nucleus-commerce/admin-kit/index-table';

import { ORGANIZATION_FILTER_FIELDS, ORGANIZATION_SORTS } from '../components/organization-filters';

/** URL search params of the organizations list route; mirrors GET /platform/v1/organizations. */
export const organizationListSearchSchema = indexSearchSchema(ORGANIZATION_FILTER_FIELDS, {
  sort: ORGANIZATION_SORTS,
});

export type OrganizationListSearch = z.infer<typeof organizationListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function organizationListParams(search: OrganizationListSearch): ListParams {
  return listParams(search, ORGANIZATION_FILTER_FIELDS);
}
